// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
if ('scrollRestoration' in history) {
	history.scrollRestoration = 'manual';
}

jQuery(function ($) {

	// クリック時（同一ページ）
	$('a[href*="#"]').on('click', function (e) {
		const href = $(this).attr('href');
		const url = new URL(href, location.href);

		if (!url.hash) return;

		if (url.pathname === location.pathname) {
			const target = $(url.hash);
			if (target.length) {
				e.preventDefault();
				const headerHeight = $('header').innerHeight();
				const pos = target.offset().top - headerHeight;
				$('html, body').stop().animate({ scrollTop: pos }, 550, 'swing');
			}
		}
	});
});

// ページ完全読み込み後（別ページからの遷移）
jQuery(window).on('load', function () {
	const hash = location.hash;
	if (!hash) return;

	const $target = jQuery(hash);
	if (!$target.length) return;

	const headerHeight = jQuery('header').innerHeight();
	const pos = $target.offset().top - headerHeight;

	// 即座に移動（animate不要）
	jQuery('html, body').scrollTop(pos);
});


// ヘッダーの固定エフェクト // Fixed header effect
jQuery(function ($) {
	var $header = $('header');
	$(window).scroll(function () {
		if ($(window).scrollTop() > 50) {
			$header.addClass('is-sticky');
		} else {
			$header.removeClass('is-sticky');
		}
	});
});


// アコーディオンの起動 // Activate the accordion
jQuery(function ($) {
	if ($('.js-accordion dt').length > 0) {
		$(".js-accordion dt").click(function () {
			$(this).next("dd").slideToggle();
			$(this).toggleClass("is-open");
		});
	}
});


// ドロワーメニュー // Drawer menu
jQuery(function ($) {
	if ($('.l-hamburger').length > 0) {
		$('.l-hamburger').click(function () {
			var parentHeader = $(this).closest('header');
			var nav = parentHeader.find('nav');
			var bg = $('.drawer_bg', parentHeader);

			$(this).toggleClass('toggle_active');
			bg.fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				nav.addClass('is-open');
				nav.removeClass('is-close');
			} else {
				nav.removeClass('is-open');
				nav.addClass('is-close');
			}
		});

		$('.drawer_bg').click(function () {
			var parentHeader = $(this).closest('header');
			var nav = parentHeader.find('nav');
			var bg = $('.drawer_bg', parentHeader);

			bg.fadeOut();
			$('.l-hamburger').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			nav.removeClass('is-open');
			nav.addClass('is-close');
		});

		// エリア内リンク用 // For links within an area
		$('nav a').on('click', function () {
			// if (window.innerWidth <= 768) {
			if ($('.l-hamburger:visible').length > 0) {
				$('.l-hamburger').click();
			}
		});
	}
});


// Navigation
jQuery(function ($) {
	let set = window.innerWidth > 1000;
	$('.js-nav').hover(function () {
		if (set) {
			$(this).addClass('is-active');
			$(this).find('.l-nav__sub-menu').stop().fadeIn(300);
		}

	}, function () {
		if (set) {
			$(this).removeClass('is-active');
			$(this).find('.l-nav__sub-menu').stop().fadeOut(300);
		}
	});

	document.querySelectorAll('.js-nav__spTrigger').forEach(trigger => {
		if (trigger.nextElementSibling.classList.contains('js-nav__spTarget')) {
			trigger.addEventListener('click', function (e) {
				if (!set) {
					e.preventDefault();
					e.stopPropagation();
					const trgr = e.target.closest('.js-nav__spTrigger');
					const wrapper = trgr.closest('.js-nav')
					const target = wrapper.querySelector('.js-nav__spTarget');

					if (wrapper.classList.contains('is-active')) {
						wrapper.classList.remove('is-active');
						jQuery(target).stop().slideUp();
					} else {
						wrapper.classList.add('is-active');
						jQuery(target).stop().slideDown();
					}
				}

			}, false);
		}
	});

	window.addEventListener('resize', function (e) {
		set = window.innerWidth > 1000;
	});
});


// モーダル
const triggers = document.querySelectorAll('.js-modal-trigger');

// モーダル開く
triggers.forEach(trigger => {
	trigger.addEventListener('click', e => {
		e.preventDefault();

		const dialogId = trigger.dataset.dialog;
		const dialog = document.getElementById(dialogId);

		if (dialog && !dialog.open) {
			dialog.showModal();
		}
	});
});

// モーダル閉じる
document.querySelectorAll('.js-modal-close').forEach(btn => {
	btn.addEventListener('click', e => {
		e.preventDefault();

		const dialog = btn.closest('dialog');
		if (dialog && dialog.open) {
			dialog.close();
		}
	});
});

// モーダル外クリックで閉じる
document.querySelectorAll('dialog').forEach(dialog => {
	dialog.addEventListener('click', e => {
		if (e.target === dialog) {
			dialog.close();
		}
	});
});






// --- GSAP等の設定 ----
// GSAP
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', function (event) {

	// --- scrollEffect ---
	if (document.querySelector('.js-slideup')) {
		document.querySelectorAll('.js-slideup').forEach(elm => {

			ScrollTrigger.create({
				toggleActions: 'play pause resume reset',
				trigger: elm,
				start: `top bottom`,
				onEnter: function () {
					elm.classList.remove('init');
				},
				onLeaveBack: function () {
					elm.classList.add('init');
				},
			});

		});
	}

});

